export default __webpack_public_path__ + "static/media/jose-antoine-costa.1a6da476.png";